import { useState } from "react";
import QRGenerator from "./component/QRGenerator";
import QRReader from "./component/QRReader";
import "./QRCode.css";
import QRInput from "./component/QRInput";

function QRCode() {
  const [url, setUrl] = useState();
  const [size, setSize] = useState(256);

  const handleUrlChange = (url) => {
    setUrl(url);
  };

  return (
    <div className="QRCode">
      <div>
        <QRReader onSuccess={handleUrlChange} />
        <QRInput url={url} onBlur={handleUrlChange} />
        <input type="number" defaultValue={size} onBlur={(e) => setSize(e.target.value)} />
      </div>
      <QRGenerator url={url} size={size} onUrlChange={handleUrlChange} />
    </div>
  );
}

export default QRCode;
